import styled from 'styled-components';

export const PersonalDataStepContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 24px;

    p {
        margin: 0;
    }

    .title {
        margin-top: 0;
        margin-bottom: 0;
        word-break: break-word;
    }

    .form {
        display: flex;
        flex-direction: column;
        gap: 20px;
        margin-top: 20px;
    }
`;
